import { baseSiteEndPoint, buildHeaders, getSellerID, urlFilters } from "./common";
import { authorizedFetch } from "./login";

export const apiUnifiedTransactionDetail = async (id) => {
  try {
    const response = await authorizedFetch(`${baseSiteEndPoint}/unified/accounts/sellers/${getSellerID()}/transactions/${id}/`, {
      method: "GET",
      headers: buildHeaders(),
    });
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiTransactionsList = async (filters) => {
  try {
    const response = await authorizedFetch(urlFilters(`${baseSiteEndPoint}/sales/seller/${getSellerID()}/transactions/`, filters), {
      method: "GET",
      headers: buildHeaders(),
    });
    const data = await response.json();

    return data;
  } catch (error) {
    throw error;
  }
};

export const apiUnifiedTransactionsList = async (filters) => {
  try {
    const response = await authorizedFetch(urlFilters(`${baseSiteEndPoint}/unified/accounts/sellers/${getSellerID()}/transactions/`, filters), {
      method: "GET",
      headers: buildHeaders(),
    });
    const data = await response.json();

    return data;
  } catch (error) {
    throw error;
  }
};

export const apiTransactionsDisputesList = async (filters) => {
  try {
    const response = await authorizedFetch(urlFilters(`${baseSiteEndPoint}/sales/seller/${getSellerID()}/chargebacks`, filters), {
      method: "GET",
      headers: buildHeaders(),
    });
    const data = await response.json();

    return data;
  } catch (error) {
    throw error;
  }
};

export const apiVoidTransaction = async (seller_id) => {
  try {
    const response = await authorizedFetch(`${baseSiteEndPoint}/sales/seller/${getSellerID()}/transactions/${seller_id}/void/`, {
      method: "POST",
      headers: buildHeaders(),
    });
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiTransactionDownload = async (format, filters) => {
  try {
    const acceptHeader =
      format === 'csv'
        ? 'text/csv'
        : 'application/vnd.ms-excel';

    const response = await authorizedFetch(urlFilters(`${baseSiteEndPoint}/unified/accounts/sellers/${getSellerID()}/transactions/report/`, filters),
      {
        method: 'GET',
        headers: {
          ...buildHeaders(),
          Accept: acceptHeader,
        },
      }
    );

    return response.blob();
  } catch (error) {
    throw error;
  }
};

export const apiCreateTransactionSplit = async (sellerId, transactionId, payload) => {
  try {
    const response = await authorizedFetch(`${baseSiteEndPoint}/unified/accounts/sellers/${sellerId}/transactions/${transactionId}/split/`, {
      method: "POST",
      headers: buildHeaders(),
      body: JSON.stringify(payload)
    });
    
    if (!response.ok) {
      const errorText = await response.text();
      const error = new Error(errorText || 'Error creating split');
      error.status = response.status;
      throw error;
    }
    
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiDeleteTransactionSplit = async (transactionId, splitId) => {
  try {
    const response = await authorizedFetch(`${baseSiteEndPoint}/unified/accounts/sellers/${getSellerID()}/transactions/${transactionId}/split/${splitId}/`, {
      method: "DELETE",
      headers: buildHeaders(),
    });
    
    if (response.ok) {
      return { success: true, message: "Split excluído com sucesso!" };
    } else {
      const data = await response.json();
      throw new Error(data.message || "Erro ao excluir o split");
    }
  } catch (error) {
    throw error;
  }
};